import React from "react";
import { FocusScope } from "react-aria";
import { Link } from "react-router-dom";

/**
 * Componente con las opciones plan de lecturas, mkmk en vivo, blog y centro de recursos
 * @param {Function} setOpenDropdown - actualiza el estado openDropdown
 * @param {boolean} openDropdown - estado que indica si se debe ver las opciones de planes
 * @param {object} textosInterfaz- contiene los textos de interfaz
 * @returns {JSX.Element} DropdownComunidad
 */
export const DropdownComunidad = ({ setOpenDropdown, openDropdown, textosInterfaz }) => {
    const subSecciones = [
        // {
        //     link: "/club-makemake",
        //     name: textosInterfaz?.club || 'Club MakeMake',
        // },
        {
            link: "/club-makemake?section=planes-de-lectura",
            name: textosInterfaz?.plan_lectura || 'Plan de lectura',
        },
        {
            link: "/club-makemake?section=makemake-en-vivo",
            name: textosInterfaz?.mkmk_vivo || 'MakeMake en vivo',
        },
        {
            link: "/blog",
            name: textosInterfaz?.blog || 'Blog',
        },
        {
            link: "/centro-de-recursos",
            name: textosInterfaz?.recursos || 'Centro de recursos',
        }
    ];

    const handleKeyDown = (e) => {
        if (e.key === "Escape") {
            setOpenDropdown(false);
        }
    };

    return (
        openDropdown &&(
            <FocusScope contain restoreFocus autoFocus>
                <ul onKeyDown={handleKeyDown}>
                    {
                        subSecciones.map((item, i) => {
                            return (
                                <li 
                                    key={`comunidad-${i}`}
                                    className={`${openDropdown ? 'activeMode' : 'inactiveMode'}`}>
                                    <Link
                                        to={item?.link || "/club-makemake"}
                                        className="focusable-red"
                                        onClick={() => setOpenDropdown(false)}
                                    >
                                        {item?.name || 'opcion'}
                                    </Link>
                                </li>
                            )
                        })
                    }
                    <li className={`close-options ${openDropdown ? 'activeMode' : 'inactiveMode'}`}>
                        <button onClick={() => setOpenDropdown(false)} aria-label={textosInterfaz?.button_close_list_alt || "Cerrar la lista desplegable"} className="w-100 focusable-red ">
                            {textosInterfaz?.button_close_list || "Cerrar"}
                        </button>
                    </li>
                </ul>
            </FocusScope>
        )
    )
}